(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-correction.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-correction.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  swe,
  sweRectangleBounds,
  mapDefaults,
  createMap,
  calculateCumulativeSumDoubledUpToIndex,
  calculateSouthCoordinate,
  isPointInsideSweden,
  findClosestCoord,
  getIconLeaflet,
  checkDuplicateWagersLocations,
  getSouthCoordinate
} = svs.tur.lyckoplatsen.map;
const formatCurrency = svs.utils.format.Currency;
const {
  CONSTANTS: {
    CORRECTION_STEP
  }
} = svs.lyckoplatsen.components.shared_constants;
const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
function getCorrectionMapHandler() {
  let map;
  let options = {};
  let result;
  let wagers;
  let sweRec;
  const eventHandlers = {};
  const gridCoords = [];
  const rads = []; 
  const leafletWinCircles = [];
  const leafletWinCirclesGrowing = [];
  const leafletWagers = [];
  const leafletWagersDistances = [];
  const triggeredWagers = new Set();
  let winCoord;
  let tlMain;
  return {
    createMap(mapOptions, mapResult) {
      let mapWagers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      let evtHandlers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      options = _objectSpread(_objectSpread({}, mapDefaults), mapOptions);
      map = createMap(options, () => eventHandlers.showMapErrorDialog());
      wagers = mapWagers;
      result = mapResult;
      this.setupWinCoord();
      if (mapWagers.length) {
        this.setupWagers(mapWagers);
      }
      Object.assign(eventHandlers, evtHandlers);
      sweRec = leaflet.rectangle(sweRectangleBounds, {
        color: 'yellow',
        fillOpacity: 0.6,
        weight: 1
      });
      map.fitBounds(sweRec.getBounds(), {
        padding: [12, 12],
        animate: false
      });
      tlMain = gsap.timeline({
        paused: true
      });
      this.initiateDrawMapExperience();
      return map;
    },
    setupWinCoord() {
      const formattedLat = parseFloat(result.location.latitude.replace(',', '.')).toFixed(6);
      const formattedLng = parseFloat(result.location.longitude.replace(',', '.')).toFixed(6);
      winCoord = [formattedLat, formattedLng];
    },
    setupWagers(mapWagers) {
      var _wagers;
      const uniqueWagersLocations = checkDuplicateWagersLocations(mapWagers);
      wagers = uniqueWagersLocations;

      if ((_wagers = wagers) !== null && _wagers !== void 0 && _wagers.length) {
        wagers.map(wager => {
          const wagerLat = parseFloat(wager.wager.bets[0].geoBoardData.geoLoc.latitude.replace(',', '.'));
          const wagerLng = parseFloat(wager.wager.bets[0].geoBoardData.geoLoc.longitude.replace(',', '.'));
          return leafletWagersDistances.push(Math.trunc(map.distance(winCoord, [wagerLat, wagerLng])));
        });
      }
    },
    removeMap() {
      map.remove();
    },
    setDefaults() {
      const tl = gsap.timeline();
      if (document.querySelector('.gsap-heart-count')) {
        tl.set('.gsap-heart-count', {
          opacity: 0,
          scale: 0.75
        });
      }
      if (document.querySelector('.gsap-pin-wager-correction')) {
        tl.set('.gsap-pin-wager-correction', {
          opacity: 0
        });
      }
      if (wagers.length) {
        wagers.forEach((wager, index) => {
          tl.set(".gsap-pin-wager-".concat(index, " svg"), {
            opacity: 0,
            height: '0px'
          });
        });
      }

      if (document.querySelector('.gsap-location-name')) {
        tl.set('.gsap-location-name', {
          opacity: 0
        });
      }
      if (document.querySelector('.gsap-location-name-child')) {
        tl.set('.gsap-location-name-child', {
          opacity: 0,
          height: 0
        });
      }
      if (document.querySelector('.gsap-top-win')) {
        tl.set('.gsap-top-win', {
          opacity: 0,
          top: '-50px'
        });
      }
      tlMain.add(tl, '>');
    },
    updateGradientBgOffset() {
      var _getComputedStyle;
      const gradientEl = document.querySelector('.gsap-map-gradient');
      const mapPaneEl = document.querySelector('.leaflet-map-pane');
      const transform = (_getComputedStyle = getComputedStyle(mapPaneEl)) === null || _getComputedStyle === void 0 ? void 0 : _getComputedStyle.transform;
      if (gradientEl && transform !== 'none') {
        const matrix = transform.match(/matrix.*\((.+)\)/)[1].split(', ');
        const translateX = parseFloat(matrix[4]) || 0;
        const translateY = parseFloat(matrix[5]) || 0;
        gradientEl.style.transform = "translate(".concat(-translateX, "px, ").concat(-translateY, "px)");
      }
    },
    addBackground() {
      if (map) {
        const gradient = document.querySelector('.map-gradient');
        if (!gradient) {
          const tgaElement = document.querySelector('.lp-map-correction .leaflet-map-pane');
          const newDiv = document.createElement('div');
          newDiv.className = 'map-gradient gsap-map-gradient js-dynamically-added';
          tgaElement.appendChild(newDiv);
        }
        this.updateGradientBgOffset();
        map.on('resize', this.updateGradientBgOffset);
        map.on('viewreset', this.updateGradientBgOffset);
      }
    },
    addDots() {
      let skipCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      let adjustRadiuses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      let orgCoords;
      let lat;
      let lng;
      const rows = 57;
      const cols = 26; 

      const latDiff = (sweRectangleBounds[0][0] - sweRectangleBounds[1][0]) / rows;
      const lngDiff = (sweRectangleBounds[0][1] - sweRectangleBounds[1][1]) / cols;

      for (let i = 0; i < rows; i++) {
        if (i === 0) {
          lat = sweRectangleBounds[0][0] - i * latDiff - latDiff / 2;
        } else {
          const distanceFromStart = calculateCumulativeSumDoubledUpToIndex(rads, i - 1).pop();
          const newLatCoord = calculateSouthCoordinate(orgCoords, distanceFromStart);
          lat = newLatCoord[0];
        }

        const lng1 = sweRectangleBounds[0][1] - Number(lngDiff) - lngDiff / 2;
        const lng2 = sweRectangleBounds[0][1] - 2 * lngDiff - lngDiff / 2;
        const rowRadius = map.distance([lat, lng1], [lat, lng2]) / 2;
        rads.push(Number(rowRadius.toFixed(0)));

        for (let j = 0; j < cols; j++) {
          lng = sweRectangleBounds[0][1] - j * lngDiff - lngDiff * 0.4; 

          if (i === 0) {
            orgCoords = [lat, lng]; 
          }
          let dotName = '';
          if (skipCheck || isPointInsideSweden([lat, lng], swe.features[0].geometry.coordinates)) {
            dotName = "gsap-dot-sweden gsap-dot-".concat(i);
            lat = Number(lat.toFixed(6));
            lng = Number(lng.toFixed(6));

            leaflet.circle([lat, lng], {
              radius: adjustRadiuses ? rads[i] * 0.84 : rads[0],
              fillColor: '#2073E5',
              fillOpacity: 1,
              weight: 0,
              className: "gsap-dot ".concat(dotName, " gsap-hide")
            }).addTo(map);
            gridCoords.push({
              lat,
              lng,
              radius: Number(rowRadius.toFixed(0))
            });
          }
        }
      }
    },
    addWinnerDot() {
      const closestCoord = findClosestCoord(winCoord[0], winCoord[1], gridCoords);
      leaflet.circle([closestCoord.lat, closestCoord.lng], {
        radius: closestCoord.radius * 0.84,
        fillColor: '#16FFAB',
        fillOpacity: 1,
        weight: 0,
        className: "gsap-dot gsap-dot-winner gsap-hide"
      }).addTo(map);
    },
    addPin() {
      const icon = getIconLeaflet({
        className: 'gsap-pin-winner gsap-hide-svg',
        color: 'green'
      });
      const pin = leaflet.marker([winCoord[0], winCoord[1]], {
        icon
      });
      pin.addTo(map);
    },
    addWagers() {
      if (!wagers.length) {
        return;
      }
      wagers.forEach((wager, index) => {
        const icon = getIconLeaflet({
          className: "pin-wager-correction gsap-pin-wager-correction gsap-pin-wager-".concat(index),
          color: 'red',
          count: wager.wagerMultiplayed
        });
        const formattedLat = parseFloat(wager.wager.bets[0].geoBoardData.geoLoc.latitude.replace(',', '.')).toFixed(6);
        const formattedLng = parseFloat(wager.wager.bets[0].geoBoardData.geoLoc.longitude.replace(',', '.')).toFixed(6);
        const pin = leaflet.marker([formattedLat, formattedLng], {
          icon
        });
        pin.setZIndexOffset((index + 1000) * (wager === null || wager === void 0 ? void 0 : wager.wagerMultiplayed));
        pin.addTo(map);
        leafletWagers.push(pin);
      });
    },
    addWinnerCircles() {
      leafletWinCircles.length = 0;
      leafletWinCirclesGrowing.length = 0;
      result.distribution.slice(1).forEach((circle, index) => {
        const leafletCircle = leaflet.circle(winCoord, {
          radius: circle.distanceMeters,
          fillColor: 'transparent',
          weight: 4,
          className: "gsap-winner-circle gsap-hide"
        });
        leafletCircle.addTo(map);
        leafletWinCircles.push(leafletCircle);
        const leafletCircleGrowing = leaflet.circle(winCoord, {
          className: "growing-winner-circle gsap-growing-winner-circle gsap-growing-circle-".concat(index, " gsap-hide"),
          radius: index === 0 ? 0 : result.distribution.slice(1)[index - 1].distanceMeters,
          fillColor: 'transparent',
          weight: 4
        });
        leafletWinCirclesGrowing.push(leafletCircleGrowing);

        leafletCircleGrowing.addTo(map);
      });
    },
    addWinnerCircleLabels() {
      const labels = [];
      map.createPane('labels');
      map.getPane('labels').style.zIndex = 401;
      const singleWinGroups = result.distribution.slice(1);
      singleWinGroups.forEach((circle, index) => {
        const labelDistance = circle.distanceMeters * 0.98;
        const labelCoord = getSouthCoordinate(winCoord, Math.trunc(labelDistance));
        const formattedWins = "".concat(formatCurrency(circle.winners), " ").concat(circle.winners === 1 ? 'vinst' : 'vinster');
        const myIcon = leaflet.divIcon({
          className: "label label-".concat(singleWinGroups.length - 1 - index, " ").concat(circle.distanceMeters < 850 ? '' : 'label-above', " gsap-label-circle-").concat(index, " gsap-hide"),
          html: "<div>".concat(formattedWins, " \xE0 ").concat(formatCurrency(circle.amountSek.slice(0, -3)), " kr<span>").concat(svs.lyckoplatsen.utils.format.formatDistance(circle.distanceMeters), "</span></div>"),
          iconSize: [0, 0]
        });
        const leafletLabel = leaflet.marker(labelCoord, {
          icon: myIcon,
          pane: 'labels',
          keyboard: false
        });
        leafletLabel.addTo(map);
        labels.push(leafletLabel);
      });
    },
    mapFitBoundsSweden() {
      if (productMapping.isLyckoplatsenPrimary(result.productId)) {
        return;
      }
      const tl = gsap.timeline({
        duration: 0.1,
        onStart: () => {
          map.fitBounds(sweRec.getBounds(), {
            padding: [12, 12],
            animate: false
          });
        }
      });
      tlMain.add(tl, '>');
    },
    animateTopWinText() {
      const tl = gsap.timeline();
      tl.to('.gsap-top-win', {
        opacity: 1,
        top: '0px',
        duration: 1,
        ease: 'power4.out'
      }, '>');
      tlMain.add(tl, '<');
    },
    animateDotsIn() {
      const dots = gsap.utils.toArray('.gsap-dot-sweden');
      const tl = gsap.timeline({
        onStart: () => {
          map.fitBounds(sweRec.getBounds(), {
            padding: [12, 12],
            animate: false
          });
        }
      });

      if (productMapping.isLyckoplatsenSecondary(result.productId)) {
        tl.add(() => {}, 0.5);
      }
      tl.to(dots, {
        fill: '#1047B8',
        opacity: 1,
        ease: 'none',
        stagger: {
          each: 0.001
        }
      });
      tlMain.add(tl, '>');
    },
    animateDotsGreen() {
      const tl = gsap.timeline();
      tl.to('.gsap-dot-sweden', {
        opacity: 1,
        fill: '#16FFAB',
        duration: 1,
        ease: 'power1.out'
      }, '>');
      tlMain.add(tl, '>');
    },
    animateDotsOut() {
      const dots = gsap.utils.toArray('.gsap-dot-sweden');
      const shuffledDots = gsap.utils.shuffle(dots);
      const tl = gsap.timeline();
      tl.set('.gsap-dot-winner', {
        opacity: 1
      });
      shuffledDots.forEach(dot => {
        const randomDelay = 1 + Math.random() * 5.5;
        tl.to(dot, {
          fill: '#1047B8',
          duration: 2,
          ease: 'power1.inOut'
        }, randomDelay);
      });
      tlMain.add(tl, '>');
    },
    mapZoomInWinner(map) {
      const tl = gsap.timeline({
        duration: 3,
        onStart: () => {
          const bounds = leafletWinCircles[0].getBounds();
          map.flyToBounds(bounds, {
            animate: true,
            duration: 3,
            easeLinearity: 0.1,
            noMoveStart: false
          });
        }
      });
      tl.to('.gsap-dot', {
        opacity: 0,
        delay: 0,
        duration: 1,
        ease: 'power4.out'
      }, '<').to('.gsap-map-gradient', {
        opacity: 0.72,
        delay: 0,
        duration: 2.5,
        ease: 'power4.out'
      }, '<');
      tlMain.add(tl, '>');
    },
    animatePin() {
      const tl = gsap.timeline();
      tl.add(gsap.timeline()).set(".gsap-pin-winner svg", {
        opacity: 0,
        height: '0px'
      }).to(".gsap-pin-winner svg", {
        opacity: 1,
        height: '80px',
        delay: 0.5,
        duration: 1.2,
        ease: 'elastic(1, 0.5)'
      }).to(".gsap-pin-winner svg", {
        width: '54px',
        duration: 0.9,
        ease: 'back.out(1.2)'
      }, '>');
      tlMain.add(tl, '>');
    },
    animatePinColor() {
      const tl = gsap.timeline();
      tl.to('.gsap-pin-winner svg path', {
        fill: '#2073E5',
        duration: 1.5,
        ease: 'power4.out'
      }, '<').to('.gsap-map-gradient', {
        opacity: 0,
        duration: 1.5,
        ease: 'power4.out'
      }, '<');
      tlMain.add(tl, '>');
    },
    animateWagers() {
      if (!wagers.length) {
        return;
      }
      const tl = gsap.timeline();
      tl.set('.gsap-pin-wager-correction', {
        opacity: 1
      });

      wagers.forEach((wager, index) => {
        tl.to(".gsap-pin-wager-".concat(index, " svg"), {
          opacity: 1,
          height: '80px',
          delay: 0.3,
          duration: 1.2,
          ease: 'elastic(1, 0.5)'
        }, '<').to(".gsap-pin-wager-".concat(index, " svg"), {
          width: '54px',
          duration: 0.9,
          ease: 'back.out(1.2)'
        }, '<');
      });
      if (document.querySelector('.gsap-heart-count')) {
        tl.to(".gsap-heart-count", {
          opacity: 1,
          scale: 1,
          duration: 0.375,
          ease: 'power4.out)'
        }, '>');
      }
      tlMain.add(tl, '>');
    },
    animateLocationName() {
      const tl = gsap.timeline({
        onStart: () => {
          const pinEl = document.querySelector('.pin-heart');
          const pinParentEl = pinEl.offsetParent.getBoundingClientRect().top;
          const pinY = pinEl.getBoundingClientRect().bottom;
          gsap.set('.lp-draw > .lp-draw-location-name-container', {
            y: pinY - pinParentEl
          });
        },
        onComplete: () => {
          eventHandlers.automatedStepUpdate(CORRECTION_STEP.DISTANCE);
        }
      });
      if (document.querySelector('.gsap-location-name')) {
        tl.to('.gsap-location-name', {
          opacity: 1,
          duration: 1,
          ease: 'power4.out'
        }, '>');
        tl.to('.gsap-location-name', {
          opacity: 0,
          delay: 2,
          duration: 1,
          ease: 'power4.out'
        }, '>');
      }
      if (document.querySelector('.gsap-location-name-child')) {
        tl.to('.gsap-location-name-child', {
          opacity: 1,
          height: '24px',
          duration: 1,
          ease: 'power4.out'
        }, '<');
      }
      tlMain.add(tl, '-=1.5');
    },
    mapSetView(map) {
      const tl = gsap.timeline({
        duration: 0.1,
        onStart: () => {
          const bounds = leafletWinCircles[0].getBounds();
          map.fitBounds(bounds, {
            animate: false
          });
        }
      });
      tlMain.add(tl, '>');
    },
    animateWagerPin(wagerIndex) {
      const el = document.querySelector(".gsap-pin-wager-".concat(wagerIndex, " svg"));
      if (!el) {
        return;
      }
      const pin = leafletWagers[wagerIndex];
      if (pin) {
        pin.openPopup();
      }
      const tl = gsap.timeline();
      tl.set(".gsap-pin-wager-".concat(wagerIndex, " svg"), {
        opacity: 0,
        height: '0px'
      });
      tl.to(".gsap-pin-wager-".concat(wagerIndex, " svg"), {
        opacity: 1,
        height: '80px',
        duration: 1.2,
        ease: 'elastic(2, 0.3)'
      }).to(".gsap-pin-wager-".concat(wagerIndex, " svg"), {
        width: '54px',
        duration: 2.5,
        rotate: 0,
        ease: 'back.out(1.2)'
      }, '<');
      tl.play();
    },
    checkAndAnimateWagers(currentRadius) {
      if (!leafletWagersDistances.length) {
        return;
      }
      for (let wagerIndex = 0; wagerIndex < leafletWagersDistances.length; wagerIndex++) {
        const wagerDistance = leafletWagersDistances[wagerIndex];
        if (currentRadius >= wagerDistance && !triggeredWagers.has(wagerIndex)) {
          this.animateWagerPin(wagerIndex);
          triggeredWagers.add(wagerIndex);
        }
      }
    },
    animateZoomStagger() {
      const flyToBoundsDuration = 1.5;
      result.distribution.slice(1).forEach((circle, index) => {
        const tl = gsap.timeline({
          onStart: () => {
            map.flyToBounds(leafletWinCircles[index].getBounds(), {
              duration: flyToBoundsDuration
            });
          }
        });

        tl.to({}, {
          duration: flyToBoundsDuration
        });

        const radiusTarget = {
          radius: 0
        };
        const throttledWagerCheck = _.throttle(() => {
          this.checkAndAnimateWagers(radiusTarget.radius);
        }, 300);
        tl.to(radiusTarget, {
          duration: 1.5,
          radius: circle.distanceMeters,
          onUpdate: () => {
            const currentRadius = radiusTarget.radius;
            leafletWinCirclesGrowing[index].setRadius(currentRadius);
            throttledWagerCheck();
          },
          ease: 'power4.out'
        }, '>');
        tl.to(".gsap-growing-circle-".concat(index), {
          duration: 1.5,
          opacity: 1,
          ease: 'power1.out'
        }, '<');
        tl.to(".gsap-label-circle-".concat(index), {
          delay: 1.25,
          opacity: 1,
          duration: 0.5,
          ease: 'power1.out'
        }, '<');
        tl.to(".gsap-label-circle-".concat(index), {
          delay: 1.75,
          opacity: 0,
          duration: 0.5,
          ease: 'power1.out'
        }, '<');
        tlMain.add(tl, '>');
      });
    },
    jumpToResult() {
      let jump = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      const tl = gsap.timeline({
        duration: 0.5,
        onComplete: () => {
          if (!wagers.length || jump) {
            eventHandlers.automatedStepUpdate(CORRECTION_STEP.RESULT);
          }
        }
      });
      tl.to(".lp-draw", {
        duration: 0.5,
        opacity: 0,
        ease: 'power1.out'
      }, '>');
      tlMain.add(tl, '>');
    },
    mapZoomInWagers(map) {
      if (!wagers.length) {
        return;
      }
      const bounds = leaflet.latLngBounds();
      const biggestCircle = leafletWinCircles[leafletWinCircles.length - 1];
      bounds.extend(biggestCircle.getBounds());
      leafletWagers.forEach(marker => {
        bounds.extend(marker.getLatLng());
      });
      const tl = gsap.timeline({
        duration: 3,
        onStart: () => {
          map.flyToBounds(bounds, {
            animate: true,
            duration: 1.5,
            easeLinearity: 0.1,
            noMoveStart: false
          });
        }
      });
      tlMain.add(tl, '>');
    },
    resetWagerPins() {
      if (leafletWagers !== null && leafletWagers !== void 0 && leafletWagers.length) {
        leafletWagers.forEach(pin => pin.closePopup());
        triggeredWagers.clear();
      }
    },
    initiateDrawMapExperience() {
      this.addBackground();
      this.addDots();
      this.addWinnerDot();
      this.addPin();
      this.addWagers();
      this.addWinnerCircles();
      this.addWinnerCircleLabels();

      this.setDefaults();

      this._labelPlace();
      this.animateDotsIn();
      this.mapFitBoundsSweden();
      this.animateWagers();
      this.animateDotsGreen();
      this.animateTopWinText();
      this.animateDotsOut();
      this.mapZoomInWinner(map);
      this.animatePin();
      this.animatePinColor();
      this.animateLocationName();

      this._labelDistance();
      this.mapSetView(map);
      this.animateZoomStagger();
      this.jumpToResult(true);
    },
    tlPlay() {
      tlMain.play();
    },
    tlPause() {
      tlMain.pause();
    },
    tlKill() {
      this.resetWagerPins();
      tlMain.kill();
    },
    tlSeek(seek) {
      this.resetWagerPins();
      if (seek === 2) {
        tlMain.seek('place');
      } else if (seek === 3) {
        tlMain.seek('distance');
      }
    },
    _labelPlace() {
      tlMain.add('place', '+=0');
    },
    _labelDistance() {
      tlMain.add('distance', '+=0');
    }
  };
}
Object.assign(svs.lyckoplatsen.components.shared_map, {
  getCorrectionMapHandler
});

 })(window);